import React, {Component, useContext, useState, useEffect} from 'react';
import {Dropdown} from 'semantic-ui-react';
import axios from 'axios'
import PollCard from './PollCard';
import PollCardCompleted from './PollCardCompleted';
import PollCardNotStarted from './PollCardNotStarted';
import {AppContext} from '../../context/app/appContext';

// var polls=[]
// var notStartedPolls=[]
// var inProgressPolls=[]
// var completedPolls=[]



export const SeeResultsTab = ({...props}) => {

    const [notStartedPolls, setNotStartedPolls] = useState([])
    const [inProgressPolls, setInProgressPolls] = useState([])
    const [completedPolls, setCompletedPolls] = useState([])
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    console.log("access token = ", accessToken)
    const appContext = useContext(AppContext)
    console.log("User Email",appContext.user)
    let data=[]
    // axios.post('http://localhost:8080/poll/fetch/hr', {email: appContext.user.email}).then(res => {
    //     console.log("Save poll data", res.data) 
    //     savePollData(res.data)
    // }).catch(error => console.log(error));

    useEffect(() => {
        console.log("before poll request ")
        axios.post(baseURL+'/poll/fetch/hr', {email: appContext.user.email},{headers : {
            Authorization: "Bearer "+localStorage.getItem('accessToken')}
        }).then(res => {
        console.log("Save poll data", res.data) 
        savePollData(res.data)
    }).catch(error => console.log(error));
    }, [])





    function savePollData(item){
        console.log("check here= ",item)


        var d1 = new Date();
        var year = d1.getFullYear();
        var month = d1.getMonth()+1;
        var day = d1.getDate();
        let temp;
        const temp1 = []
        const temp2 = []
        const temp3 = []
        for (const i of item){

            if(i.startDate==undefined || i.startDate.length==8) continue;
            if(i.endDate==undefined || i.endDate.length==8) continue;
            // console.log("item details = ", i)
            const year1 = parseInt(i.startDate.slice(0,4))
            const month1 = parseInt(i.startDate.slice(5,7))
            const day1 = parseInt(i.startDate.slice(8,10))
            const year2 = parseInt(i.endDate.slice(0,4))
            const month2 = parseInt(i.endDate.slice(5,7))
            const day2 = parseInt(i.endDate.slice(8,10))
            // console.log("dates = ", year)
            

            var level=0
            //1 completed -1 not started 0 in progress
            if(year2<year ||(month2<month && year2==year)||(day2<day && month2==month && year2==year)){level=1}


            if(year1>year){level=-1}
            if(month1>month && year1==year){level=-1}
            if(day1>day && year1==year && month1==month){level=-1}
            console.log("level = ", level)

            if(level==-1){
                temp1.push(i)
            }
            else if(level==1){
                temp2.push(i)
            }
            else{
                temp3.push(i)
            }

        }
        console.log("in progress data = ", inProgressPolls)
        console.log("completed data = ", completedPolls)
        console.log("not started data = ", notStartedPolls)
        setNotStartedPolls(temp1);
        setCompletedPolls(temp2);
        setInProgressPolls(temp3);
        
    }
    function notStarted(formEdit){
        const pollData = notStartedPolls
        console.log("Inside in progress = "+ pollData)
        var card = []
        for(const i of pollData){
            card.push(<PollCardNotStarted formEdit={formEdit} item={i}/>)
        }
        return(
            <div className="not-started-cont">
                <div className="poll-cont-heading">Not Started</div>
                {/* <PollCard item={pollData[0]}/>
                <PollCard item={pollData[1]}/>
                <PollCard item={pollData[2]}/>
                <PollCard item={pollData[3]}/>
                <PollCard item={pollData[4]}/> */}
                {card}
        
            </div>
        );
    }
    function inProgress() {
        const pollData = inProgressPolls
        console.log("Inside in progress = "+ pollData)
        var card = []
        for(const i of pollData){
            card.push(<PollCard item={i}/>)
        }
        return(
            <div className="in-progress-cont">
                <div className="poll-cont-heading">In Progress</div>
                {/* <PollCard item={pollData[0]}/>
                <PollCard item={pollData[1]}/>
                <PollCard item={pollData[2]}/>
                <PollCard item={pollData[3]}/>
                <PollCard item={pollData[4]}/> */}
                {card}
        
            </div>
        );
    }
    function completed(){
        const pollData = completedPolls
        var card = []
        for(const i of pollData){
            card.push(<PollCardCompleted item={i}/>)
        }
        return(
            <div className="completed-cont">
                <div className="poll-cont-heading">Completed</div>
                {card}

            </div>
        )
    }
    console.log("Check if this goes = ", inProgressPolls)
    return( 
        
            <div style={{width: '100%'}}>
                
                <div className="see-result-cont-header">

                </div>
                <div className="see-result-cont">
                    {notStarted(props.formEdit)}
                    
                    {inProgress()}
                    {completed()}
                </div>
            </div>



    )  
}


